module.exports = __webpack_public_path__ + "ab89e14b0cc5a5a6df9f83b150425ab2.svg";